import { type OnesaasConsent } from "../portals/messagemedia/onesaas-consent-cookie";
import { shouldEnforcePurpose, type TrackEventPayload } from "./eventTypes";

const cookieConsentPurposeMapping: Record<
  "Functional" | "Marketing" | "Analytical",
  keyof OnesaasConsent
> = {
  Functional: "onesaascookie_acceptance",
  Analytical: "onesaascookie_performance",
  Marketing: "onesaascookie_targeting",
};

export const hasUserConsentedToEvent = (
  eventpayload: TrackEventPayload,
  isConsentRequired = true,
  givenConsent: Partial<OnesaasConsent> = {}
) => {
  if (!isConsentRequired) {
    return true;
  }

  if (eventpayload.purposes) {
    return eventpayload.purposes.every(
      (purpose) => givenConsent[cookieConsentPurposeMapping[purpose]] === "true"
    );
  }

  return shouldEnforcePurpose(eventpayload.appName, eventpayload.name);
};
